import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { browserHistory } from 'react-router';

import Page from 'components/Pages/container';
import dineInMessages from 'components/dineInMessages';
import { isDineInOrderingFlow } from 'selectors/root';

import { StyledTitle, StyledButton } from './styles';

const PreAuthRequired = ({ isDineInFlow, serviceId }) => {
  useEffect(() => {
    if (!isDineInFlow) browserHistory.replace(`/service/${serviceId}`);
  }, [isDineInFlow, serviceId]);

  return (
    <Page
      settingsPage={true}
      titleMessage={dineInMessages.addPaymentMethod}
      headerOnlyTitle={true}
      hideBackButton={true}
    >
      <StyledTitle>
        <FormattedMessage {...dineInMessages.groupAddPaymentMethod} />
      </StyledTitle>
      <StyledButton to="" label={<FormattedMessage {...dineInMessages.addNow} />} primaryButton={true} />
      <StyledButton to="" label={<FormattedMessage {...dineInMessages.noAction} />} primaryButton={true} />
    </Page>
  );
};

PreAuthRequired.propTypes = {
  isDineInFlow: PropTypes.bool,
  serviceId: PropTypes.string,
};

export default connect((state, { params }) => ({
  isDineInFlow: isDineInOrderingFlow(state, params?.serviceId),
  serviceId: params?.serviceId,
}))(PreAuthRequired);
